import React, { useEffect, useState } from "react";
import { IconJumbotron } from "../../common/icons";
import { useLocation } from "react-router-dom";

// List of known URLs that require login
const LOGIN_REQUIRED_URLS = [
  // Book Related
  "bookdetails",
  "creatorbook",
  "rate",
  "creatorrate",
  "reader",
  "creator_reader",
  "books",
  "teacher_books",
  "library",

  // Profile & Settings
  "editprofile",
  "settings",
  "youraccount",
  "cancelplan",
  "purchaseplan",
  "payment",
  "thankyou",

  // Student Management
  "students",
  "transferstudents",
  "addstudents",
  "howstudentsignup",
  "student",

  // Assignments & Grades
  "assignments",
  "grades",
  "assignment",
  "new_assignment",
  "edit_assignment",
  "answerkeys",

  // Creator/Authors
  "creators",
  "creators_manage",
  "creator",

  // Other Features
  "achievements",
  "search",
  "navigation",
  "notifications",
  "refer_friend",

  // Support & Help
  "contact",
  "support",
  "general/support",
  "general",
  "faq",
  "general/faq",
];

const Page_404: React.FC = () => {
  const location = useLocation();
  const [isLoginRequired, setIsLoginRequired] = useState(false);

  useEffect(() => {
    // Check if the current path matches any of the login required URLs
    const requiresLogin = LOGIN_REQUIRED_URLS.some((url) => {
      const location_url = location.pathname.split("/");
      return location_url.includes(url);
    });
    setIsLoginRequired(requiresLogin);
  }, [location]);

  if (isLoginRequired) {
    return (
      <main className="first-container m">
        <div className="text-center my-5 d-flex justify-content-center">
          <IconJumbotron
            icon="fas fa-lock"
            txt="Login Required"
            txt_classes="mt-3"
            size="md"
            help_text="This page requires you to be logged in to view it"
            cta={{
              txt: "Log in",
              classes: "btn btn-primary btn_lg",
              link: "/signin",
            }}
            secondary_cta={{
              txt: "Don't have an account? Get started here",
              classes: "btn btn-link text_underline",
              link: "/signup",
            }}
          />
        </div>
      </main>
    );
  }

  return (
    <main className="first-container m">
      <div className="text-center my-5">
        <IconJumbotron
          icon="fas fa-exclamation-triangle"
          txt="404"
          txt_classes="mt-3"
          help_text="Page not found"
          cta={{
            txt: "Go back to home",
            classes: "btn btn-primary",
            link: "/",
          }}
        />
      </div>
    </main>
  );
};

export default Page_404;
